import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[72px] w-full rounded border border-input bg-white px-2.5 py-1.5 text-[13px] leading-snug shadow-none placeholder:text-muted-foreground/80 hover:border-foreground/30 focus-visible:outline-none focus-visible:border-shell-primary focus-visible:ring-1 focus-visible:ring-shell-primary/40 disabled:cursor-not-allowed disabled:bg-muted/40 disabled:opacity-80",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
